import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Alert, Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import { useContext } from "react";

const CredoraComingSoon = ({
  mainTitle = "Credora360",
  parent = "Operations",
  title = "Coming soon",
  description = "This LoanProX-aligned screen is planned for a future release.",
  relatedPath,
  relatedLabel,
}) => {
  const { layoutURL } = useContext(CustomizerContext);
  const relatedHref = relatedPath ? `${relatedPath}/${layoutURL}` : null;

  return (
    <Fragment>
      <Breadcrumbs mainTitle={mainTitle} parent={parent} title={title} />
      <Container fluid>
        <Alert color="light" className="border">
          <h5 className="mb-2">{title}</h5>
          <p className="mb-2 text-muted">{description}</p>
          {relatedHref && relatedLabel ? (
            <Link to={relatedHref} className="btn btn-primary btn-sm">
              {relatedLabel}
            </Link>
          ) : null}
        </Alert>
      </Container>
    </Fragment>
  );
};

export default CredoraComingSoon;
